import { FC } from 'react';
import Link from 'next/link';
import { defineMessages, useIntl } from 'react-intl';
import { ActivityStatisticsCard } from 'src/apps/Activities/ActivityStatisticsCard';
import { ROUTES } from 'src/constants/routes.const';
import useSafePush from 'src/hooks/useSafePush';
import { Icon } from 'src/components';
import { TrackingApi } from 'src/api';
import { useUserContext } from 'src/context/user';
import { getLanguagePairId } from 'src/utils/language/getLanguagePairId';
import { useRandomActivity } from './useRandomActivity';
import * as S from './styles';

const msgs = defineMessages({
  title: { id: 'myActivities_screenTitle' },
  intervalSuffix: { id: 'homeScreen_myActivities_widget_statDescription_7days' },
});

const INTERVAL_LENGTH_DAYS = 7;

export const MyActivitiesDashboardCard: FC = () => {
  const intl = useIntl();
  const { safePush } = useSafePush();
  const { user } = useUserContext();
  const randomActivity = useRandomActivity(INTERVAL_LENGTH_DAYS);
  const handleClick = () => {
    /* istanbul ignore next: analytics */
    void TrackingApi.trackUserAction(
      'clicked_home_card',
      'dashboard_home_tab',
      getLanguagePairId(),
      !!user?.isPro,
      { card: 'my_activities' },
    );
    void safePush(ROUTES.myActivities);
  };

  return (
    <S.CardWrapper>
      <S.CardOverlay data-testid="home_my_activities" onClick={handleClick} />
      <S.Header onClick={handleClick}>
        <Icon name="statistics" />
        <S.Title>{intl.formatMessage(msgs.title)}</S.Title>
        <Link href={ROUTES.myActivities} passHref legacyBehavior>
          <S.ArrowButton aria-label={intl.formatMessage(msgs.title)}>
            <Icon name="displayRight" />
          </S.ArrowButton>
        </Link>
      </S.Header>
      {randomActivity && (
        <ActivityStatisticsCard
          title={`${intl.formatMessage(randomActivity.labelMessage)} ${intl.formatMessage(msgs.intervalSuffix)}`}
          value={randomActivity.stat}
          difference={randomActivity.statDifference}
          type={randomActivity.type}
        />
      )}
    </S.CardWrapper>
  );
};
